module.exports = __webpack_public_path__ + "img/transfer-created.878c85f9.svg";